import { Helmet } from "react-helmet";
import {
  Box,
  Typography,
  Card,
  CardContent,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Sidebar from "../../sidebar/sidebar";
import OnlineTransfer from "./components/onlineTransfer";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useAppStore } from "../../../appStore";
import HwlMobileTransferPage from "./HwlMobileTransferPage";

function TransferOnlinePage() {
  const { profileData } = useAppStore();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (profileData?.userLoginType === "HWL" && isMobile) {
    return <HwlMobileTransferPage />;
  }

  return (
    <>
      <Helmet>
        <title>S - M ( M-India ) Spot-Money | Online Transfer</title>
      </Helmet>
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 1,
            background: `url(${process.env.PUBLIC_URL}/images/logo-background.png) center/250px no-repeat fixed`,
            minHeight: "100vh",
          }}
        >
          <Box height={{ xs: 60, md: 90 }} />
          {profileData?.walletTansferStatus === "inactive" ? (
            <Card
              sx={{
                maxWidth: 500,
                mx: "auto",
                mt: 4,
                p: 2,
                backgroundColor: "#fff3e0",
                borderLeft: "6px solid #ff9800",
                boxShadow: 3,
                borderRadius: 2,
              }}
            >
              <CardContent sx={{ textAlign: "center" }}>
                <WarningAmberIcon sx={{ fontSize: 50, color: "#ff9800" }} />
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", mt: 2, color: "#e65100" }}
                >
                  ID Transfer Disabled
                </Typography>
                <Typography variant="body1" sx={{ mt: 1, color: "#795548" }}>
                  Your ID wallet transfer is currently <strong>inactive</strong>
                  . Please contact your administrator for help or to reactivate
                  access.
                </Typography>
              </CardContent>
            </Card>
          ) : (
            <OnlineTransfer />
          )}
        </Box>
      </Box>
    </>
  );
}

export default TransferOnlinePage;
